import { httpService } from './http';

interface SellerLeadValueResult {
    readonly error: string;
    readonly message: string;
    readonly detail: string;
}

interface SellerLeadValuePayload {
    isSeller: boolean;
    isDuplicate: boolean;
    propertyCountry: string;
    propertyPostalCode: string;
    timeToSell?: string;
    estimatedPropertyPrice: number;
}

const WLEF_API_URL = process.env['NX_WLEF_API_URL'];
const WLEF_API_KEY = process.env['NX_WLEF_API_KEY'];

// Get the estimated Seller Lead Value for a given estimation and current knowledge
export const sellerLeadValue = async (
    payload: SellerLeadValuePayload,
): Promise<SellerLeadValueResult> => {
    const { data } = await httpService.post<SellerLeadValueResult>(
        `${WLEF_API_URL}/v1/seller-lead`,
        payload,
        {
            headers: {
                'x-api-key': WLEF_API_KEY,
            },
        },
    );
    return data;
};
